import { render, staticRenderFns } from "./EventList.vue?vue&type=template&id=8c94d296&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=ts"
export * from "./EventList.vue?vue&type=script&lang=ts"
import style0 from "./EventList.vue?vue&type=style&index=0&id=8c94d296&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c94d296",
  null
  
)

export default component.exports